import React from 'react'
import { withContext } from 'ddiForm'
import { getIn, is } from 'utils'
import { useDispatch } from 'react-redux'
import { Button } from '@material-ui/core'
import { debounce, noop } from 'lodash'
import { removeModal } from 'modals/actions'
import { handleBackorderCommitmentSchedule } from '../../../actions'

const marginRight = { marginRight: 5 }

const ActionButtons = ({
  balance,
  form,
  modalId,
  onClickLoadScheduleButton = noop,
  isEditing
}) => {
  const dispatch = useDispatch()

  const cancelBackorders = debounce(e => {
    dispatch(
      handleBackorderCommitmentSchedule.try(form, {
        apiParams: {
          action: 'cancel'
        },
        modalId
      })
    )
  }, 300)

  const commitBackorders = debounce(e => {
    dispatch(
      handleBackorderCommitmentSchedule.try(form, {
        apiParams: {
          action: 'ok'
        },
        modalId
      })
    )
  }, 300)

  return (
    <div
      className="sales-order-entry-modal-action-buttons"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 0 0 0'
      }}
    >
      <p
        style={{
          alignItems: 'center',
          display: 'flex',
          fontSize: '1em',
          margin: 0
        }}
      >
        <span style={{ marginRight: 3 }}>Balance:</span>
        <span>{balance}</span>
      </p>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          padding: '10px 0 0 0'
        }}
      >
        <Button
          onClick={onClickLoadScheduleButton}
          variant="contained"
          style={marginRight}
          tabIndex={-1}
        >
          Load Schedule
        </Button>
        <Button
          onClick={commitBackorders}
          variant="contained"
          style={marginRight}
          tabIndex={-1}
          disabled={!isEditing}
        >
          OK
        </Button>
        <Button onClick={cancelBackorders} variant="contained" tabIndex={-1}>
          Exit
        </Button>
      </div>
    </div>
  )
}

export default ActionButtons
